import * as types from '../actions/actionTypes';
import { loginSucceeded } from '../actions/dashboardAction';
import { ofType } from 'redux-observable';
import { mergeMap, map } from 'rxjs/operators';
import { ajax } from 'rxjs/ajax';
import { dashboardDomain } from '../../ApiHelper';

export const loginEpic = action$ => action$.pipe(
    ofType(types.LOGIN_REQUEST),
    mergeMap(action =>
        ajax.getJSON(`${dashboardDomain}code/database.php?function=createSecurityTagTemp&params=${action.id}~${action.id}`).pipe(
        map(response => loginSucceeded(response))
      )
    )
);